// extracted by mini-css-extract-plugin
export default {"wirelessTable":"WirelessStep_wirelessTable__S+YOb"};